<template>
  <v-dialog v-model="frontpageSettingsInforDialog" width="800">
    <v-card v-if="$vuetify.breakpoint.smAndUp">
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <span class="display-1 text-uppercase font-weight-bold">{{$t('infoDialogs.private.frontpageArticle.Title')}}</span>
        <v-spacer></v-spacer>
        <v-btn color="error" :title="$t('infoDialogs.private.frontpageArticle.Close window')" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col md="12">
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.frontpageArticle.PageDescription')}}</span>
          </v-col>
          <v-col md="12">
            <v-tabs grow >
              <v-tab>{{$t('infoDialogs.private.frontpageArticle.Sport')}}</v-tab>
              <v-tab>{{$t('infoDialogs.private.frontpageArticle.Politics')}}</v-tab>
              <v-tab>{{$t('infoDialogs.private.frontpageArticle.Music')}}</v-tab>
            </v-tabs>
          </v-col>
          <v-col md="12">
            <span><v-btn class="success mr-2" small>{{$t('infoDialogs.private.frontpageArticle.Save and Create')}}</v-btn></span>
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.frontpageArticle.PageActionsOne')}}</span>
          </v-col>
          <v-col md="12">
            <span><v-btn class="success mr-2" small>{{$t('infoDialogs.private.frontpageArticle.Update')}}</v-btn></span>
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.frontpageArticle.PageActionsTwo')}}</span>
          </v-col>
          <v-col md="12">
            <span class="mr-2"><v-btn class="warning" small>{{$t('infoDialogs.private.frontpageArticle.Delete')}}</v-btn></span>
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.frontpageArticle.PageActionsThree')}}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--Phone-->
    <v-card v-else>
      <v-row>
        <!--Title and close button-->
        <v-col cols="12" class="py-0">
          <v-row class="ma-0 pa-0">
            <!--Title-->
            <v-col cols="8" class="pt-6">
              <span class="title text-uppercase font-weight-bold">{{$t('infoDialogs.private.frontpageArticle.Title')}}</span>
            </v-col>
            <v-spacer></v-spacer>
            <!--Close Button-->
            <v-col cols="auto">
              <v-btn color="error" :title="$t('infoDialogs.private.frontpageArticle.Close window')" class="ma-2" outlined icon large @click="closeDialog">
                <v-icon>close</v-icon>
              </v-btn>
            </v-col>
            <v-divider></v-divider>
          </v-row>
        </v-col>
        <!--Page description-->
        <v-col cols="12" class="py-0 pl-6 pb-3">
          <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.frontpageArticle.PageDescription')}}</span>
        </v-col>
        <!--Example Tabs-->
        <v-col cols="12" class="py-0">
          <v-tabs center-active grow dark>
            <v-tab>{{$t('infoDialogs.private.frontpageArticle.Sport')}}</v-tab>
            <v-tab>{{$t('infoDialogs.private.frontpageArticle.Politics')}}</v-tab>
            <v-tab>{{$t('infoDialogs.private.frontpageArticle.Music')}}</v-tab>
          </v-tabs>
        </v-col>
        <!--Create Profile-->
        <v-col cols="12" class="py-0 pt-6">
          <v-row class="ma-0 pa-0">
            <!--Create Button-->
            <v-col cols="12" class="py-0">
              <v-btn block class="success mr-2" small>Create profile</v-btn>
            </v-col>
            <!--Create Description-->
            <v-col cols="12" class="py-0">
              <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.frontpageArticle.PageActionsOne')}}</span>
            </v-col>
          </v-row>
        </v-col>
        <!--Update Profile-->
        <v-col cols="12" class="py-0 pt-6">
          <v-row class="ma-0 pa-0">
            <!--Update Button-->
            <v-col cols="12" class="py-0 pb-2">
              <v-btn block class="success mr-2" small>Update</v-btn>
            </v-col>
            <!--Update Description-->
            <v-col cols="12" class="py-0">
              <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.frontpageArticle.PageActionsTwo')}}</span>
            </v-col>
          </v-row>
        </v-col>
        <!--Delete profile-->
        <v-col cols="12" class="py-0 pt-6 pb-6">
          <v-row class="ma-0 pa-0">
            <!--Delete Button-->
            <v-col cols="12" class="py-0">
              <v-btn block class="warning" small>Delete</v-btn>
            </v-col>
            <!--Delete Description-->
            <v-col cols="12" class="py-0">
              <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.frontpageArticle.PageActionsThree')}}</span>
            </v-col>
          </v-row>
        </v-col>
        <!--More?-->
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
// Import the i18n - This may need to be modified
import messages from "../../modules/lang/export";
export default {
  // Communicate with i18n
  i18n: { messages },
  data(){
    return{
      // Define the dialog v-model that we are using
      frontpageSettingsInforDialog:false,
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
      this.frontpageSettingsInforDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.frontpageSettingsInforDialog = false;
    }
  }
}
</script>